// extracted by mini-css-extract-plugin
export var container = "_br-0";